import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ApplicationStatus } from '@regigov/contracts';
import { applicationsApi } from '../../api/participants';
import { ProblemAlert, StatusBadge, formatDateTime } from '../../components/ui';

const OPEN: ApplicationStatus[] = ['submitted', 'under_assessment', 'returned'];

export function ApplicationsQueue() {
  const [status, setStatus] = useState<ApplicationStatus | 'open' | ''>('open');
  const list = useQuery({
    queryKey: ['applications', status],
    queryFn: () => applicationsApi.list(status === 'open' || status === '' ? undefined : status),
  });
  const items = (list.data?.items ?? []).filter((a) => status !== 'open' || OPEN.includes(a.status));

  return (
    <>
      <p className="crumbs">
        <Link to="/cer/participants">Participants</Link> / Applications
      </p>
      <h1>Participant applications</h1>
      <div className="row">
        <label>
          Show
          <select value={status} onChange={(e) => setStatus(e.target.value as ApplicationStatus | 'open' | '')}>
            <option value="open">Open (submitted, under assessment, returned)</option>
            <option value="">All</option>
            {ApplicationStatus.options.map((s) => (
              <option key={s} value={s}>
                {s.replace(/_/g, ' ')}
              </option>
            ))}
          </select>
        </label>
      </div>
      <ProblemAlert error={list.error} />
      {list.isLoading && <p className="muted">Loading…</p>}
      {list.data && items.length === 0 && <p className="muted">No applications match.</p>}
      {items.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>Organisation</th>
              <th>ABN</th>
              <th>Type</th>
              <th>Status</th>
              <th>Submitted</th>
              <th>Assessor</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id}>
                <td>
                  <Link to={`/cer/participants/applications/${a.id}`}>{a.legalName}</Link>
                </td>
                <td>{a.abn}</td>
                <td>{a.participantType}</td>
                <td>
                  <StatusBadge status={a.status} />
                </td>
                <td>{formatDateTime(a.submittedAt)}</td>
                <td>{a.assessorName ?? <span className="muted">unassigned</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
